import { useState } from 'react';
import Modal from '../../../../components/Modal/Modal';
import Button from '../../../../components/Button/Button';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import * as Styled from '../../PerfisUsuarios.styles';
import TextField from '../../../../components/TextField';
import SelectOptions from '../../../../components/SelectOptions';
import InputMask from '../../../../components/InputMask';
import validateSenha from '../../../../utils/functions/ValidatePassword';
import PasswordCheckList from '../../../../components/PasswordCheckList/PasswordCheckList';
import { createSystemUserFetchAction } from '../../../../store/fetchActions/systemUserActions';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import { useForm } from 'react-hook-form';
import { IconButton, InputAdornment } from '@mui/material';
import { VisibilityOff, Visibility } from '@mui/icons-material';

const CreateUser = ({ open, close, info }) => {
  const [passwordCheckList, setPasswordCheckList] = useState('');
  const [passwordCheckListValid, setPasswordCheckListValid] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrong, setPasswordStrong] = useState(false);
  const [fone, setFone] = useState();
  const [cpf, setCpf] = useState();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { handleSubmit, control, register } = useForm({});

  const callCreateSystemUserAction = (data) => {
    delete data.create_user;
    let parans = {
      CONFIRMARSENHA: passwordCheckListValid,
      CPFCNPJCOBAN: cpf,
      EMAIL: data.EMAIL,
      FONECEL: fone,
      ID_PERFIL: data.ID_PERFIL,
      NOME: data.NOME,
      SENHA: passwordCheckList,
    };
    passwordStrong
      ? dispatch(createSystemUserFetchAction(parans, close))
      : dispatch(
          showAlert({
            title: 'Atenção',
            text: 'Sua senha precisa ser mais forte. Para garantir a segurança, não é permitido o uso de números  sequenciais. Ex: (123, 321)',
            icon: 'warning',
          }),
        );
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Modal open={open} close={close} title="Criar Usuário">
      <form onSubmit={handleSubmit(callCreateSystemUserAction)}>
        <Styled.SectionInputs>
          <InputMask
            label="CPF"
            name={'CPFCNPJCOBAN'}
            width={'29.306vw'}
            control={control}
            required={true}
            mask={'999.999.999-99'}
            onChange={(e) => setCpf(e)}
            variant={'filled'}
          />
        </Styled.SectionInputs>
        <Styled.SectionInputs>
          <TextField
            control={control}
            label={'Nome'}
            disabled={false}
            width={'29.306vw'}
            name={'NOME'}
            variant={'filled'}
            required={true}
          />
        </Styled.SectionInputs>
        <Styled.SectionInputs>
          <TextField
            control={control}
            label={'E-mail'}
            disabled={false}
            width={'29.306vw'}
            name={'EMAIL'}
            variant={'filled'}
            type={'email'}
            required={true}
          />
        </Styled.SectionInputs>
        <Styled.SectionInputs>
          <InputMask
            label="Telefone"
            name={'FONECEL'}
            width={'29.306vw'}
            control={control}
            required={true}
            mask={'(99) 99999-9999'}
            onChange={(e) => setFone(e)}
            variant={'filled'}
          />
        </Styled.SectionInputs>

        <Styled.Line />

        <Styled.SectionInputs>
          <SelectOptions
            control={control}
            options={info}
            name={'ID_PERFIL'}
            width={'29.306vw'}
            initialValue={1}
            required={true}
            variant={'filled'}
            label={'Nível Acesso'}
          />
        </Styled.SectionInputs>

        <Styled.Line />

        <Styled.SectionInputs>
          <TextField
            inputProps={{
              maxLength: 32,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            control={control}
            label={'Senha'}
            disabled={false}
            width={'29.306vw'}
            name={'SENHA'}
            variant={'filled'}
            type={showPassword ? 'text' : 'password'}
            required={true}
            {...register('SENHA', {
              onChange: (e) => setPasswordCheckList(e.target.value),
            })}
          />
        </Styled.SectionInputs>
        <Styled.SectionInputs>
          <TextField
            inputProps={{
              maxLength: 32,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            control={control}
            label={'Confirmar Senha'}
            disabled={false}
            width={'29.306vw'}
            name={'CONFIRMARSENHA'}
            type={showPassword ? 'text' : 'password'}
            variant={'filled'}
            required={true}
            {...register('CONFIRMARSENHA', {
              onChange: (e) => setPasswordCheckListValid(e.target.value),
            })}
          />
        </Styled.SectionInputs>
        <PasswordCheckList
          name={'create_user'}
          value={passwordCheckList}
          valueAgain={passwordCheckListValid}
          control={control}
          onChange={(e) => setPasswordStrong(e)}
        />
        <Button
          backgroundcolor={theme.colors.buttonConfirm}
          width={'29.306vw'}
          height={'3.125vw'}
          margin={'2vw 0 0 0'}
          hoverbgcolor={theme.colors.buttonConfirmHover}
          hovercolor={theme.colors.buttonConfirmHoverText}
          mycolor={theme.colors.buttonConfirmText}
          disabled={!passwordStrong}
          type="submit"
        >
          <span>CRIAR</span>
        </Button>
      </form>
    </Modal>
  );
};

export default CreateUser;
